// File: src/pages/JobDetail.jsx
import React, { useEffect, useState } from 'react';
import { Container, Typography, Paper, List, ListItem, ListItemText, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function JobDetail() {
    const { jobId } = useParams();
    const [details, setDetails] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchDetails() {
            try {
                const response = await fetch(`/api/job/${jobId}/details`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.ok) {
                    const data = await response.json();
                    setDetails(data);
                }
            } catch (error) {
                console.error("Error fetching job details:", error);
            } finally {
                setLoading(false);
            }
        }
        fetchDetails();
    }, [jobId]);

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Job Details (Job ID: {jobId})
            </Typography>
            <Paper>
                <List>
                    {details.map(detail => (
                        <ListItem key={detail.id}>
                            <ListItemText
                                primary={`${detail.StepName} - ${detail.Status}`}
                                secondary={`Started: ${new Date(detail.startTime).toLocaleString()} ${detail.endTime ? `| Ended: ${new Date(detail.endTime).toLocaleString()}` : ''} ${detail.log ? `| Log: ${detail.log}` : ''}`}
                            />
                        </ListItem>
                    ))}
                    {details.length === 0 && (
                        <ListItem>
                            <ListItemText primary="No step details available." />
                        </ListItem>
                    )}
                </List>
            </Paper>
        </Container>
    );
}
